import React from "react";
import { RiPencilRuler2Line } from "react-icons/ri";
import { GoGraph } from "react-icons/go";
import { AiOutlineTags } from "react-icons/ai";
import { MdChangeCircle } from "react-icons/md";
const Why = () => {
  return (
    <div className="mb-5 p-5">
      <div className="text-center">
        <h1 className="text-3xl">WHY CHOOSE US?</h1>
        <h1 className="italic text-xl">
          Find reasons to choo
          <span className="underline decoration-red-500 underline-offset-8">
            se us as your ware
          </span>
          house partner
        </h1>
      </div>
      <div className="flex space-x-8 mt-8 p-2">
        <div>
          <div className="flex">
            <h1 className="text-7xl text-red-400">
              <RiPencilRuler2Line />
            </h1>
            <h1 className="ml-5">
              <span className="text-xl">Customer Satisfication Tools </span>{" "}
              <br />
              <span>
                The word cargo refers in particular to goods or produce being
                conveyed generally for commercial gain by ship, boat, or
                aircraft, although the term is now often extended to cover all
                types of freight, including that carried by train, van, truck,
                or intermodal container.
              </span>
            </h1>
          </div>
          <br />
        </div>
        <div>
          <div className="flex">
            <h1 className="text-7xl text-red-400">
              <AiOutlineTags />
            </h1>
            <h1 className="ml-5">
              <span className="text-xl">Freight Payment Options </span> <br />
              <span>
                The word cargo refers in particular to goods or produce being
                conveyed generally for commercial gain by ship, boat, or
                aircraft, although the term is now often extended to cover all
                types of freight, including that carried by train, van, truck,
                or intermodal container.
              </span>
            </h1>
          </div>
          <br />
        </div>
      </div>
      <div className="flex space-x-8 mt-4 p-2">
        <div>
          <div className="flex">
            <h1 className="text-7xl text-red-400">
              <GoGraph />
            </h1>
            <h1 className="ml-5">
              <span className="text-xl">Management & Reporting </span> <br />
              <span>
                The word cargo refers in particular to goods or produce being
                conveyed generally for commercial gain by ship, boat, or
                aircraft, although the term is now often extended to cover all
                types of freight, including that carried by train, van, truck,
                or intermodal container.
              </span>
            </h1>
          </div>
          <br />
        </div>
        <div>
          <div className="flex">
            <h1 className="text-7xl text-red-400">
              <MdChangeCircle />
            </h1>
            <h1 className="ml-5">
              <span className="text-xl">Compliance Solutions </span> <br />
              <span>
                The word cargo refers in particular to goods or produce being
                conveyed generally for commercial gain by ship, boat, or
                aircraft, although the term is now often extended to cover all
                types of freight, including that carried by train, van, truck,
                or intermodal container.
              </span>
            </h1>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default Why;
